export default class Scrolly {
  constructor(element) {
    this.element = element;
    this.options = {
      rootMargin: '0px', //représente les marges qui contiennent les limites
    };
    this.init();
  }

  init() {
    const observer = new IntersectionObserver( // instancie un observateur qui détecte les éléments qui touche la marge (Voir documentation)
      this.watch.bind(this), //appelle la fonction qui regarde les détections
      this.options //détermine les marges
    );

    const items = this.element.querySelectorAll('[data-scrolly]');
    for (let i = 0; i < items.length; i++) {
      const item = items[i];
      observer.observe(item); //pour chaque élément, l'observe
    }
  }

  watch(entries, observer) {
    //octroie des entrées au regard des détections
    for (let i = 0; i < entries.length; i++) {
      const entry = entries[i];
      const target = entry.target; //définie une entrée pour chaque élément à detecter

      if (entry.isIntersecting) {
        // quand un élément touche aux marges
        target.classList.add('is-active');
        if ('noRepeat' in target.dataset) {
          observer.unobserve(target); //ne surveille plus l'élément si on désire ne pas répéter l'animation
        }
      } else {
        target.classList.remove('is-active');
      }
    }
  }
}
